export default __webpack_public_path__ + "static/media/hamburger_menu.7881c2ee.svg";